import React from 'react';
import { Translate } from '../../../../../language';
import ImageNameDescription from '../../../../../utils/components/ImageNameDescription/ImageNameDescription';
import Options from '../../../../../utils/components/Options/Options';
import style from './AdminRoom.module.css'
const AdminRoomRequests = ({ requests, accept,reject }) => {
    return (
        <div className={style.content_right_container}>
            <div className={style.list_item}>

                {requests.map(member => {
                    let src = null
                    let id = null;
                    let name = null;
                    let lastname = null;
                    if (member.memberType ==="user") {
                        id = member.memberUserId._id
                        name = member.memberUserId.name
                        lastname = member.memberUserId.lastname
                        src = member.memberUserId.picture && member.memberUserId.picture.url && member.memberUserId.picture.url.small
                    }
                    if (member.memberType ==="franchise") {
                        id = member.memberFranchiseId._id
                        name = member.memberFranchiseId.socialReason
                        src = member.memberFranchiseId.picture && member.memberFranchiseId.picture.url && member.memberFranchiseId.picture.url.small
                    }
                    if (member.memberType ==="representative") {
                        id = member.memberRepresentativeId._id
                        name = member.memberRepresentativeId.userID.name
                        lastname = member.memberRepresentativeId.userID.lastname
                        src = member.memberRepresentativeId.userID.picture &&
                            member.memberRepresentativeId.userID.picture.url &&
                            member.memberRepresentativeId.userID.picture.url.small
                    }
                    if (member.memberType ==="warehouse") {
                        id = member.memberWarehouseId._id
                        name =  member.memberWarehouseId.name
                        src = member.memberWarehouseId.profileId.picture &&
                            member.memberWarehouseId.profileId.picture.url &&
                            member.memberWarehouseId.profileId.picture.url.small
                    }
                    return (
                        <div key={member._id}>
                            <ImageNameDescription
                                type={"header-message"}
                                srcImage={src}
                                firstName={name}
                                secondName={lastname}
                                typeOneText="purple"
                                options={[

                                    {
                                        text: Translate('accept', 'es'), onClick: (e) => {
                                            e.preventDefault(); e.stopPropagation();
                                            accept(id,member._id)
                                        }
                                    },
                                    {
                                        text: Translate('reject', 'es'), onClick: (e) => {
                                            e.preventDefault(); e.stopPropagation();
                                            reject(id,member._id)
                                        }
                                    },
                                ]}

                            />

                        </div>
                    )
                }
                )}
            </div>
        </div>
    )
};

export default AdminRoomRequests;
